<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid w-100"  style="overflow: hidden; min-height: 80vh">
      <navbar :title="$t('menu.delivery_notes')" class="mb-2"/>
      <delivery-note-search
          class="pt-2"
          :contracts="contracts"
          :show-storages="true"
          @search="fetchDeliveryNotes"
      />
    <div
      class="button-container nopads pr-3 pb-1"
    >
      <button
        v-if="isObserver"
        class="btn btn-outline-success form-button"
        @click="addNote"
      >
        {{ $t('common.add_new') }}
      </button>
      <button
        class="btn btn-outline-success form-button"
        :disabled="notes.length === 0"
        @click="downloadDeliveryNoteExcel"
      >
        {{ $t('common.download_excel') }}
      </button>
    </div>
      <delivery-note-list
        v-if="notes.length > 0"
        class="pl-3 pr-3 pb-3"
        :notes="notes"
        :is-observer="isObserver"
        @edit="editNote"
      />
    <base-modal v-if="editMode" hide-footer hide-header size="lg" @close="editMode = false">
      <delivery-note-editor
        v-if="editMode"
        :note="deliveryNote"
        :contracts="contracts"
        @update="update"
        @close="showDeliveriesList"
      />
    </base-modal>
    <base-modal v-if="addMode" hide-footer hide-header size="lg" @close="addMode = false">
      <delivery-note-editor
        :note="newDeliveryNote()"
        :contracts="contracts"
        @update="onAddSuccess"
        @close="addMode = false"
      />
    </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {downloadHelper} from '../mixins/DownloadMixin'
import {deliveryNoteHelper} from '../mixins/DeliveryNoteMixin'
import DeliveryNoteList from "@/components/materials/DeliveryNoteList";
import DeliveryNoteSearch from "@/components/materials/DeliveryNoteSearch";
import DeliveryNoteEditor from "@/components/materials/DeliveryNoteEditor";
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'Deliveries',
    components: {
        BaseModal,
        Navbar,
        DeliveryNoteEditor,
        DeliveryNoteSearch,
        DeliveryNoteList
    },
    mixins: [timeUtils, downloadHelper, restApi, deliveryNoteHelper],
    props: {
        isObserver: Boolean,
        user: {
            type: Object,
            required: true
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: 0,
            contracts: [],
            notes: [],
            editMode: false,
            addMode: false,
            deliveryNote: null
        }
    },
    mounted: function () {
        this.fetchContracts()
    },
    methods: {
        fetchDeliveryNotes: function (params) {
            this.loading++
            this.notes = []
            if (!params) {
                params = {}
            }
            if (this.selectedStation) {
                params.station = this.selectedStation.id
            } else {
                params.station = this.station
            }
            this.lastSearchParams = params
            this.restFetchParams(this.materialDeliveryUrl, this.lastSearchParams, this.fetchNotesSuccess, this.fetchFail)
        },
        fetchContracts: function () {
            this.loading++
            let params = {}
            if (this.station) {
                let station = this.stations.find(x => x.id === this.station)
                if (station) {
                    params.contractor = station.company.id
                }
            }
            params.startDate = this.getStartOfTheDay(new Date())
            params.endDate = this.getEndOfTheDay(new Date())
            this.restFetchParams(this.contractOpenUrl, params, this.contractsSuccess, this.fetchFail)
        },
        fetchNotesSuccess: function (response) {
            this.notes = response.data
            this.loading--
        },
        contractsSuccess: function (response) {
            this.contracts = response.data
            this.loading--
        },
        fetchFail: function () {
            this.loading--
        },
        update: function () {
            this.showDeliveriesList()
            this.fetchDeliveryNotes(this.lastSearchParams)
        },
        editNote: function (note) {
            // Infra environment - Allow editing only, if the user is contractor
            if ((note.order && this.user.company.id == note.order.contract.contractor.id) || this.user.company.id == note.vehicle.company.id) {
                this.deliveryNote = note
                this.editMode = true
            }
        },
        showDeliveriesList: function () {
            this.editMode = false
            this.deliveryNote = null
        },
        addNote: function () {
            this.addMode = true
        },
        onAddSuccess: function () {
            this.addMode = false
            this.fetchDeliveryNotes(this.lastSearchParams)
        },
        downloadDeliveryNoteExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.materialDeliveryReportUrl + '/excel',
                this.getCommonReportParams( this.lastSearchParams),
                this.downloadSuccess,
                this.downloadFail)
        },
        downloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('material_reports.deliveries_file_name'))
        },
        downloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        }
    }
}
</script>
